import { useEffect, useState } from "react";
import "../assets/css/Sidebar.css";
import { useNavigate } from "react-router-dom";
import { fetchWithToken } from "../utils/fetchWithToken";
import { useAuth } from './context/AuthContext.tsx';

function Sidebar({ onLogout, activePage = "insights" }) {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const selectedAgencyId = sessionStorage.getItem("REACT_APP_AGENCY_ID");

  const [agencyName, setAgencyName] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("selectedClientId");
    localStorage.removeItem("selectedClientName");
    sessionStorage.removeItem("agencyName");
    logout();
  };

  useEffect(() => {
    const storedAgencyName = sessionStorage.getItem("agencyName");
    if (storedAgencyName) {
      setAgencyName(storedAgencyName);
    } else {
      fetchAgency();
    }
  }, []);

  const fetchAgency = async () => {
    try {
      const response = await fetchWithToken(
        `https://ad-insights-api-0f2fcea0deda.herokuapp.com/api/agency/list`
      );

      const data = await response.json();
      const agencyRaw = data?.data || [];
      const filteredClient = agencyRaw.find(agency => agency._id === selectedAgencyId);
      if (filteredClient) {
        const agencyName = filteredClient.name;
        setAgencyName(agencyName);
        sessionStorage.setItem("agencyName", agencyName);
      }
    } catch (error) {
      console.error("Erro ao buscar agências:", error);
    }
  };

  return (
        <>

    <button className="sidebar-toggle" onClick={toggleSidebar}>
        <i className="ti ti-menu-2"></i>
      </button>
      <div className={`sidebar ${isOpen ? "open" : ""}`}>
      <div className="sidebar-content">
        <div className="logo-container">
          <svg
            width="158"
            height="30"
            viewBox="0 0 158 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="logo-svg"
          >
            <g clipPath="url(#clip0_logo)">
              <path
                d="M11.9416 10.2899L11.9503 10.2812V10.2899H11.9416Z"
                fill="white"
              ></path>
              <path
                d="M11.9416 10.2899L11.9503 10.2812V10.2899H11.9416Z"
                fill="white"
              ></path>
              <path
                d="M20.8546 11.9513C20.8546 16.9266 16.8627 20.9626 11.9416 20.9626C7.02053 20.9626 3.03721 16.9266 3.03721 11.9513C3.03721 6.97593 7.02913 2.94868 11.9416 2.94868V0C5.42892 0 0.120689 5.36677 0.120689 11.9513C0.120689 18.5358 5.42892 23.9026 11.9416 23.9026C18.4543 23.9026 23.7625 18.5445 23.7625 11.9513H20.8632H20.8546Z"
                fill="#4285F3"
              ></path>
              <path
                d="M7.81207 11.9515C7.81207 14.2652 9.66177 16.1266 11.9416 16.1266C14.2215 16.1266 16.0712 14.2652 16.0712 11.9515H11.9416V7.77637C9.67038 7.77637 7.81207 9.64647 7.81207 11.9515Z"
                fill="#4285F3"
              ></path>
              <path
                d="M18.1102 1.47023L16.6304 3.9927L15.2109 6.42819C14.8581 6.21074 14.471 6.02808 14.0752 5.8889L14.9614 3.22726L15.8991 0.443848C16.6562 0.704793 17.4047 1.04402 18.1102 1.47023Z"
                fill="#4285F3"
              ></path>
              <path
                d="M21.517 4.53206L19.2113 6.30648L16.9745 8.02002C16.7336 7.6808 16.4411 7.36766 16.1141 7.09802L17.9552 4.94957L19.8566 2.74023C20.2609 3.08816 20.6395 3.47088 21.0008 3.88839C21.1815 4.10585 21.3621 4.3146 21.517 4.53206Z"
                fill="#4285F3"
              ></path>
              <path
                d="M23.4528 8.42891L20.6653 9.24654L18.0241 10.0207C17.895 9.61187 17.7316 9.22045 17.5337 8.84643L19.9856 7.533L22.5494 6.15869C22.9366 6.88934 23.2377 7.64608 23.4528 8.42891Z"
                fill="#4285F3"
              ></path>
              <path
                d="M31.8238 23.8937H35.2565L37.3127 19.1967H43.9716L46.045 23.8937H49.5036L40.6508 4.60986L31.8238 23.8937ZM43.1199 16.5872H38.1988L40.6508 10.7943L43.1199 16.5872Z"
                fill="#282828"
              ></path>
              <path
                d="M60.2663 13.8996C59.8792 13.2733 59.3974 12.7688 58.8296 12.3861C58.0811 11.8816 57.2035 11.6293 56.2142 11.6293C55.2248 11.6293 54.244 11.8816 53.3579 12.3774C52.4717 12.8732 51.7663 13.5864 51.2328 14.5171C50.6994 15.4478 50.4327 16.5786 50.4327 17.9007C50.4327 19.2228 50.6994 20.3275 51.2328 21.2669C51.7663 22.2063 52.4717 22.9283 53.3579 23.4154C54.244 23.9112 55.1904 24.1634 56.2142 24.1634C57.2379 24.1634 58.0811 23.9112 58.8296 23.4067C59.3974 23.0239 59.8706 22.5195 60.2663 21.8845V23.9025H63.0796V3.54004H60.2663V13.8996ZM59.7673 19.9709C59.4318 20.5363 59.0016 20.9625 58.4854 21.2582C57.9692 21.554 57.4358 21.7018 56.8852 21.7018C56.2486 21.7018 55.6635 21.554 55.1129 21.2582C54.5709 20.9625 54.1322 20.5276 53.8138 19.9535C53.4869 19.3794 53.3234 18.6923 53.3234 17.892C53.3234 17.0918 53.4869 16.4046 53.8138 15.8306C54.1408 15.2565 54.5709 14.8216 55.1129 14.5258C55.6549 14.2301 56.24 14.0822 56.8852 14.0822C57.4358 14.0822 57.9692 14.2301 58.4854 14.5258C59.0016 14.8216 59.4318 15.2565 59.7673 15.8219C60.1028 16.3872 60.2663 17.0831 60.2663 17.9007C60.2663 18.7183 60.0942 19.4055 59.7673 19.9709Z"
                fill="#282828"
              ></path>
              <path
                d="M77.6105 5.62744H74.5133V23.8936H77.6105V5.62744Z"
                fill="#282828"
              ></path>
              <path
                d="M87.7538 11.6293C86.9451 11.6293 86.2482 11.8033 85.6546 12.1512C85.061 12.4991 84.5706 13.0297 84.192 13.743V11.8902H81.3788V23.8937H84.192V16.5873C84.192 16.048 84.2953 15.5696 84.519 15.1608C84.7426 14.7519 85.0352 14.4388 85.4309 14.2214C85.8267 14.0039 86.2912 13.8908 86.8246 13.8908C87.5645 13.8908 88.1151 14.117 88.4765 14.5693C88.8378 15.0216 89.0185 15.6914 89.0185 16.5786V23.885H91.8834V16.2393C91.8834 14.8128 91.5306 13.6908 90.8252 12.8644C90.1197 12.0381 89.0959 11.6206 87.7538 11.6206V11.6293Z"
                fill="#282828"
              ></path>
              <path
                d="M102.104 17.5789C101.554 17.2658 100.943 16.9788 100.272 16.7178C99.7899 16.5265 99.3597 16.3438 98.9639 16.1698C98.5768 15.9959 98.2671 15.8045 98.0348 15.5784C97.8025 15.3609 97.682 15.1174 97.682 14.839C97.682 14.5085 97.8111 14.2562 98.0692 14.0823C98.3273 13.9083 98.6628 13.8213 99.0758 13.8213C99.6608 13.8213 100.229 13.9692 100.779 14.2649C101.33 14.5607 101.794 14.9434 102.173 15.4131L103.722 13.7431C103.395 13.3429 102.999 12.9863 102.534 12.6732C102.07 12.36 101.545 12.1078 100.969 11.9164C100.392 11.7251 99.7813 11.6294 99.1274 11.6294C98.4047 11.6294 97.7337 11.7512 97.1056 11.986C96.4776 12.2209 95.9786 12.5775 95.6086 13.0646C95.2387 13.5517 95.0494 14.1606 95.0494 14.8912C95.0494 15.6219 95.2129 16.1959 95.5484 16.6656C95.884 17.1353 96.3141 17.5094 96.8389 17.7964C97.3637 18.0834 97.8971 18.3357 98.4219 18.5444C98.9553 18.7358 99.4199 18.9185 99.8157 19.1011C100.211 19.2838 100.521 19.5012 100.745 19.7535C100.969 20.0057 101.08 20.3015 101.08 20.6581C101.08 21.0582 100.943 21.3713 100.659 21.5975C100.375 21.8237 99.9791 21.9367 99.4801 21.9367C99.0844 21.9367 98.6886 21.8584 98.2929 21.7019C97.8971 21.5453 97.51 21.3192 97.1314 21.0234C96.7529 20.7277 96.3657 20.3624 95.97 19.9275L94.344 21.5975C94.6881 22.0498 95.1183 22.4847 95.6345 22.8848C96.1507 23.2936 96.7443 23.6242 97.4153 23.8764C98.0864 24.1287 98.8349 24.2504 99.6608 24.2504C100.951 24.2504 101.975 23.9025 102.741 23.2241C103.506 22.5369 103.894 21.6323 103.894 20.5015C103.894 19.7709 103.73 19.1794 103.403 18.7271C103.076 18.2748 102.638 17.8921 102.087 17.5789H102.104Z"
                fill="#282828"
              ></path>
              <path
                d="M109.434 11.8901H106.673V23.8936H109.434V11.8901Z"
                fill="#282828"
              ></path>
              <path
                d="M108.04 5.39258C107.576 5.39258 107.163 5.55784 106.819 5.88837C106.466 6.2189 106.285 6.62772 106.285 7.11482C106.285 7.60191 106.466 7.98463 106.819 8.32386C107.171 8.66309 107.576 8.83705 108.04 8.83705C108.539 8.83705 108.961 8.66309 109.305 8.32386C109.649 7.98463 109.821 7.58452 109.821 7.11482C109.821 6.64512 109.649 6.2189 109.305 5.88837C108.961 5.55784 108.539 5.39258 108.04 5.39258Z"
                fill="#282828"
              ></path>
              <path
                d="M122.21 13.8648C121.823 13.2473 121.341 12.7515 120.773 12.3774C120.025 11.8816 119.147 11.6294 118.158 11.6294C117.168 11.6294 116.188 11.8729 115.302 12.36C114.415 12.8471 113.701 13.543 113.177 14.465C112.643 15.3783 112.376 16.4917 112.376 17.8138C112.376 19.1359 112.643 20.258 113.177 21.18C113.71 22.102 114.415 22.8065 115.302 23.2936C116.188 23.7807 117.134 24.0243 118.158 24.0243C119.182 24.0243 120.025 23.7807 120.773 23.2849C121.341 22.9109 121.814 22.4064 122.21 21.7889V23.6416C122.21 24.5462 122.038 25.2855 121.711 25.8596C121.375 26.4337 120.937 26.8599 120.403 27.1382C119.87 27.4166 119.319 27.5558 118.751 27.5558C118.08 27.5558 117.495 27.4253 116.996 27.173C116.497 26.9208 116.11 26.5816 115.835 26.1553C115.56 25.7291 115.413 25.2507 115.396 24.7114H112.609C112.643 25.7552 112.91 26.6772 113.409 27.4775C113.908 28.2777 114.613 28.8953 115.525 29.3389C116.437 29.7825 117.53 30.0086 118.803 30.0086C119.887 30.0086 120.894 29.7738 121.823 29.3215C122.752 28.8605 123.509 28.1559 124.077 27.2165C124.645 26.2771 124.937 25.0855 124.937 23.6416V11.899H122.201V13.8648H122.21ZM121.711 19.8753C121.375 20.4319 120.954 20.8495 120.429 21.1452C119.913 21.4322 119.38 21.5801 118.829 21.5801C118.192 21.5801 117.607 21.4322 117.065 21.1452C116.523 20.8582 116.093 20.4319 115.766 19.8666C115.439 19.3012 115.276 18.6227 115.276 17.8138C115.276 17.0049 115.439 16.3351 115.766 15.7784C116.093 15.2217 116.523 14.8042 117.065 14.5085C117.607 14.2128 118.201 14.0736 118.829 14.0736C119.242 14.0736 119.646 14.1519 120.042 14.3084C120.438 14.465 120.799 14.7085 121.126 15.0304C121.453 15.3522 121.711 15.7436 121.917 16.2046C122.115 16.6656 122.21 17.1962 122.21 17.8051C122.21 18.6227 122.038 19.3099 121.711 19.8666V19.8753Z"
                fill="#282828"
              ></path>
              <path
                d="M137.025 12.0729C136.423 11.725 135.674 11.5511 134.779 11.5511C133.885 11.5511 133.119 11.7772 132.491 12.2208C131.958 12.5948 131.536 13.0906 131.209 13.6995V3.54004H128.396V23.8938H131.209V16.5873C131.209 16.048 131.312 15.5783 131.536 15.1782C131.751 14.7781 132.052 14.4649 132.457 14.2388C132.852 14.0126 133.317 13.8996 133.85 13.8996C134.607 13.8996 135.158 14.1257 135.511 14.578C135.863 15.0303 136.044 15.7001 136.044 16.5873V23.8938H138.857V16.1959C138.857 15.1695 138.702 14.3171 138.393 13.6212C138.083 12.9341 137.627 12.4209 137.025 12.0729Z"
                fill="#282828"
              ></path>
              <path
                d="M145.516 7.71533H142.781V11.8905H140.767V14.3694H142.781V23.8939H145.516V14.3694H147.504V11.8905H145.516V7.71533Z"
                fill="#282828"
              ></path>
              <path
                d="M157.389 18.7271C157.062 18.2748 156.623 17.8921 156.073 17.5789C155.522 17.2658 154.911 16.9788 154.24 16.7178C153.758 16.5265 153.328 16.3438 152.941 16.1698C152.554 15.9959 152.244 15.8045 152.012 15.5784C151.78 15.3609 151.659 15.1174 151.659 14.839C151.659 14.5085 151.788 14.2562 152.046 14.0823C152.304 13.9083 152.64 13.8213 153.053 13.8213C153.638 13.8213 154.206 13.9692 154.756 14.2649C155.307 14.5607 155.772 14.9434 156.15 15.4131L157.699 13.7431C157.372 13.3429 156.976 12.9863 156.511 12.6732C156.047 12.36 155.522 12.1078 154.946 11.9164C154.369 11.7251 153.758 11.6294 153.104 11.6294C152.382 11.6294 151.702 11.7512 151.074 11.986C150.446 12.2209 149.947 12.5775 149.577 13.0646C149.207 13.5517 149.027 14.1606 149.027 14.8912C149.027 15.6219 149.199 16.1959 149.526 16.6656C149.861 17.1353 150.291 17.5094 150.816 17.7964C151.341 18.0834 151.866 18.3357 152.399 18.5444C152.932 18.7358 153.397 18.9185 153.793 19.1011C154.188 19.2838 154.498 19.5012 154.722 19.7535C154.946 20.0057 155.057 20.3015 155.057 20.6581C155.057 21.0582 154.911 21.3713 154.627 21.5975C154.343 21.8237 153.948 21.9367 153.457 21.9367C153.061 21.9367 152.666 21.8584 152.27 21.7019C151.874 21.5453 151.487 21.3192 151.109 21.0234C150.73 20.7277 150.343 20.3624 149.947 19.9275L148.321 21.5975C148.665 22.0498 149.095 22.4847 149.612 22.8848C150.128 23.2936 150.721 23.6242 151.392 23.8764C152.063 24.1287 152.812 24.2504 153.638 24.2504C154.928 24.2504 155.952 23.9025 156.718 23.2241C157.484 22.5369 157.862 21.6323 157.862 20.5015C157.862 19.7709 157.699 19.1794 157.372 18.7271H157.389Z"
                fill="#282828"
              ></path>
            </g>
            <defs>
              <clipPath id="clip0_logo">
                <rect
                  width="157.759"
                  height="30"
                  fill="white"
                  transform="translate(0.120689)"
                ></rect>
              </clipPath>
            </defs>
          </svg>
        </div>

        <div className="profile-section">
          <div className="profile-image-container">
            <div className="profile-text-container">
              <div className="profile-greeting">
                <p className="greeting-text">
                  Olá, <strong>{agencyName || ""}</strong>!
                </p>
                <p className="greeting-question">O que vamos fazer hoje?</p>
              </div>
            </div>
          </div>

          <div className="divider"></div>

          <div className="menu-items">
            <div
              className={`menu-item ${activePage === "insights" ? "active" : ""}`}
              onClick={() => navigate("/")}
            >
              <i className="ti ti-chart-line"></i>
              <span>Insights</span>
            </div>
            <div
              className={`menu-item ${activePage === "team" ? "active" : ""}`}
              onClick={() => navigate("/team")}
            >
              <i className="ti ti-users"></i>
              <span>Clientes</span>
            </div>
            <div
              className={`menu-item ${activePage === "settings" ? "active" : ""}`}
              onClick={() => navigate("/settings")}
            >
              <i className="ti ti-settings"></i>
              <span>Configurações</span>
            </div>
          </div>
        </div>

        <div className="logout-container">
          <div className="divider"></div>
          <div className="menu-item logout-button" onClick={handleLogout}>
            <i className="ti ti-logout"></i>
            <span>Sair</span>
          </div>
        </div>
      </div>
    </div>
        </>
  );
}

export default Sidebar;
